<template>
  <v-container>
     <div class="breadcrumb-wrap">
       <v-breadcrumbs :items="breadcrumbs"/>
     </div>
     <div class="form-npa edit law-edit">
       <div class="position">
         <div class="bg-white p-20">
           <form action="">
             <div class="form-head">
               <Widget position="menu_profile"/>
               <LawNormViewTable
                  :norm="norm"
               />
               <LawNormViewStage
                  :norm="norm"
                  :stage="stage"
                  @save="update"
                  @clear:stage="clearStage"
               />
               <LawNormViewStageTable
                  :stages="norm.normStages"
                  @edit-stage="editStage"
                  @delete-stage="deleteStage"
               />
             </div>
           </form>
         </div>
       </div>
     </div>
   </v-container>
 </template>
 <script>
 import mixin from '@/plugins/mixin/mixin'
 import LAW from '@/model/law'
 import Widget from '@/components/app/Widget'
 import {Trans} from "@/plugins/Translation"
 import { mapMutations } from 'vuex'
 import LawNormViewTable from '@/components/law/LawNormViewTable.vue'
 import LawNormViewStage from '@/components/law/LawNormViewStage.vue'
 import LawNormViewStageTable from '@/components/law/LawNormViewStageTable.vue'

 export default {
   name: "NormView",
   mixins: [mixin],
   components: {
    Widget,
    LawNormViewTable,
    LawNormViewStage,
    LawNormViewStageTable
   },

   data () {
      return {
        breadcrumbs: [],
        norm: null,
        stage: null
      }
   },

   mounted () {
    this.fetchData()
   },

   methods: {
    ...mapMutations(['setLoading']),
    generateBreadcrumbs() {
      this.breadcrumbs = [
        {text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile'},
        {text: this.$i18n.t('Исполнение законов'), disabled: false, href: Trans.currentLocaleUrl + '/law'},
        {text: this.norm.law.transName, disabled: false, href: Trans.currentLocaleUrl + '/law-view/' + this.norm.law.id},
        {text: this.norm.normText, disabled: true},
      ]
    },

    fetchData () {
      this.setLoading(true)
      LAW.getNorm(this.$route.params.id).then((response) => {
        this.norm = response.data
        this.generateBreadcrumbs()
        this.setLoading(false)
      })
    },

    update (form) {
      this.setLoading(true)
      LAW.addNormStage(this.norm.law.id, this.norm.id, form).then((response) => {
        this.fetchData()
        this.setLoading(false)
      }).catch(() => {
        this.setLoading(false)
      })
    },

    editStage (stage) {
      this.stage = stage
    },

    deleteStage (stage) {
      this.setLoading(true)
      LAW.deleteNormStage(this.norm.law.id, this.norm.id, stage).then((response) => {
        this.fetchData()
        this.setLoading(false)
      }).catch(() => {
        this.setLoading(false)
      })
    },

     clearStage() {
       this.stage = null
     }
   }
 }
 </script>
